module.exports = __webpack_public_path__ + "static/media/Public_40.713be4aa.jpg";